import { MailerTemplateVariableItem } from '../../../types'

export interface HolidayEmailPreset {
    id: string
    label: string
    subject: string
    content: string
    variables: MailerTemplateVariableItem[]
}

// Body-only content — Rails auto-wraps based on `mailer_template_type`:
// - type = 'campaign' (our default) → notification layout: logo banner, header
//   "Customer: {id}", auto-greeting "Kính gửi Quý Khách hàng (<name>)", gradient
//   bar, VNETWORK JSC corporate footer. BE prepends "VNETWORK - " to subject.
// - type = 'marketing' → marketing layout: sales-person signature block.
// Subject stored WITHOUT "VNETWORK - " prefix (BE adds it idempotently).
// Do NOT include DOCTYPE, logo, or signature in content — layout handles both.
// Style matches prod template 20 / 22 / 34 (VNIS, 30-04 2025): flat
// <p style="margin:0"> for list items, <strong> for section headers.
const HOTLINE_BLOCK = `<p style="margin-top:1.5rem;margin-bottom:0.25rem"><strong>Hotline Hỗ trợ khẩn cấp</strong>:</p>
<p style="margin:0;margin-top:0">- Mr. Nguyễn Kim Thọ: 0931 331 192</p>
<p style="margin:0;margin-top:0">- Mr. Phạm Văn Anh: 0987 575 129</p>
<p style="margin:0;margin-top:0">- Mr. Nguyễn Hữu Tài: 0355 023 153</p>
<p style="margin:0;margin-top:0">- Ms. Nguyễn Minh Anh Phương: 0902 389 645</p>
<p style="margin:0;margin-top:0">- Ms. Trần Hà My: 0965 322 503</p>`

const buildHolidayContent = (
    holidayName: string,
    supportDateRange: string
): string => `<p style="margin-top:1rem;margin-bottom:1rem">Nhân dịp ${holidayName}, VNETWORK kính chúc Quý Khách hàng và gia đình một kỳ nghỉ lễ vui vẻ, an lành và tràn đầy hạnh phúc.</p>
<p style="margin-top:1rem;margin-bottom:1rem">Để đảm bảo hệ thống dịch vụ của Quý Khách hàng hoạt động ổn định và liên tục trong suốt kỳ nghỉ lễ, VNETWORK trân trọng thông báo kế hoạch hỗ trợ kỹ thuật như sau:</p>
<p style="margin-top:1.5rem;margin-bottom:0.25rem"><strong>Thời gian hỗ trợ 24/7</strong>:</p>
<p style="margin:0;margin-top:0">- ${supportDateRange}</p>
<p style="margin-top:1.5rem;margin-bottom:0.25rem"><strong>Phương thức hỗ trợ</strong>:</p>
<p style="margin:0;margin-top:0">- Hỗ trợ kỹ thuật từ xa</p>
${HOTLINE_BLOCK}
<p style="margin-top:1.5rem;margin-bottom:1rem">Đội ngũ VNETWORK luôn sẵn sàng đồng hành cùng Anh/Chị. Chúc Anh/Chị một kỳ nghỉ lễ an toàn và trọn vẹn!</p>`

export const HOLIDAY_EMAIL_PRESETS: HolidayEmailPreset[] = [
    {
        id: 'gio-to-hung-vuong-2026',
        label: 'Giỗ Tổ Hùng Vương 2026',
        subject: 'Thông báo v/v hỗ trợ kỹ thuật trong dịp Lễ Giỗ Tổ Hùng Vương',
        content: buildHolidayContent(
            'Lễ Giỗ Tổ Hùng Vương',
            'Từ ngày 25/04/2026 đến hết ngày 27/04/2026'
        ),
        variables: [],
    },
    {
        id: 'dai-le-30-04-01-05-2026',
        label: 'Đại Lễ 30/04 - 01/05 (2026)',
        subject: 'Thông báo v/v hỗ trợ kỹ thuật trong dịp Đại Lễ 30/04 - 01/05',
        content: buildHolidayContent(
            'Đại Lễ 30/04 - 01/05',
            'Từ ngày 30/04/2026 đến hết ngày 03/05/2026'
        ),
        variables: [],
    },
]

// Prod convention: holiday/announcement templates use type 'campaign' (Template
// #52 Tết 2026) or 'service' (Template #22 2025, #34 VNIS). Both flow through
// the same Rails marketing layout. Default to 'campaign' since that's how
// broadcast templates are categorized post-refactor.
export const HOLIDAY_TEMPLATE_TYPE = 'campaign'
